module.exports = __webpack_public_path__ + "img/couturme.7425d1c0.jpg";